import _extends from "/usr/app/node_modules/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["sx", "file", "tooltip", "onRemove", "imageView", "slotProps", "onDownload"];
import React from "react";
var __jsx = React.createElement;
import { fileData, fileThumb, fileFormat } from '../utils/file-thumbnail';
import styles from '../styles/FileThumbnail.module.css';

// ----------------------------------------------------------------------

var FileThumbnail = function FileThumbnail(_ref) {
  var sx = _ref.sx,
    file = _ref.file,
    tooltip = _ref.tooltip,
    onRemove = _ref.onRemove,
    imageView = _ref.imageView,
    slotProps = _ref.slotProps,
    onDownload = _ref.onDownload,
    other = _objectWithoutProperties(_ref, _excluded);
  var previewUrl;
  if (typeof file !== 'string' && file.url) {
    previewUrl = file.url;
  } else if (typeof file === 'string') {
    previewUrl = file;
  } else {
    previewUrl = URL.createObjectURL(file);
  }
  var _fileData = fileData(file),
    name = _fileData.name,
    path = _fileData.path;
  var format = fileFormat(path || previewUrl);
  if (typeof file !== 'string' && file.url) {
    format = 'image';
  }
  var renderImg = /*#__PURE__*/React.createElement("img", {
    src: previewUrl,
    className: styles.img,
    style: slotProps === null || slotProps === void 0 ? void 0 : slotProps.img
  });
  var renderIcon = /*#__PURE__*/React.createElement("img", {
    src: fileThumb(format),
    className: styles.icon,
    style: slotProps === null || slotProps === void 0 ? void 0 : slotProps.icon
  });
  var renderContent = /*#__PURE__*/React.createElement("span", _extends({
    className: styles.root,
    style: sx
  }, other), format === 'image' && imageView ? renderImg : renderIcon, onRemove && /*#__PURE__*/React.createElement(React.Fragment, null)
  // <RemoveButton
  //     onClick={onRemove}
  //     className={styles.removeBtn}
  //     style={slotProps?.removeBtn}
  // />
  , onDownload && /*#__PURE__*/React.createElement(React.Fragment, null)
  // <DownloadButton
  //     onClick={onDownload}
  //     className={styles.downloadBtn}
  //     style={slotProps?.downloadBtn}
  // />
  );
  return renderContent;
};
export default FileThumbnail;